import React from "react";
import { useLanguage } from "../LanguageContext";

const Partners: React.FC = () => {
    const { t } = useLanguage();
    const p = t.partners;
    const titleLines = p.title.split("\n");
    const track = [...p.items, ...p.items];

    return (
        <section className="partners" id="partners">
            <div className="section-number on-light">05</div>
            <div className="container">
                <span className="section-eyebrow">{p.eyebrow}</span>
                <h2 className="section-title dark">
                    {titleLines[0]}<br />{titleLines[1]}
                </h2>
                <p className="section-intro">{p.intro}</p>
            </div>

            <div className="partners-carousel">
                <div className="partners-track">
                    {track.map((item, i) => (
                        <a className="partner-card" key={i} href={"url" in item ? (item.url as string) : undefined} target="_blank" rel="noopener noreferrer">
                            <div className="partner-logo-wrap">
                                {(item.slug as string) ? (
                                    <img
                                        src={`/logos/${item.slug}.${item.ext}`}
                                        alt={`${item.name} logo`}
                                        className={`partner-logo-img${item.darken ? " partner-logo-darken" : ""}${"imgClass" in item && item.imgClass ? ` ${item.imgClass}` : ""}`}
                                    />
                                ) : (
                                    <span className="partner-text-logo">{item.name}</span>
                                )}
                            </div>
                            <h3>{item.name}</h3>
                            <p>{item.desc}</p>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Partners;
